import { ELCLogger, TriggerType } from '@estee/elc-logging';
import {
    AllServicesTypes,
    AllUpdatedServicesTypes,
    IAppConfig,
    ILazyServiceRegistryComponent,
    root
} from '@estee/elc-universal-utils';
import { ViewManager } from './ViewManager';
import { isServiceLazy, hasServiceStarted } from '../utils';
import { getServices } from '../utils/index';
import { PerformanceMarker } from '@estee/elc-telemetry';

// TODO: remove after SDFEFND-1853
const EXCLUDED_SERVICES = ['ecomm', 'translation', 'config', 'sign'];

export class ViewsManager {
    public lazyServicesStarted = false;
    private logger: ELCLogger;
    private views = new Map<string, ViewManager>();
    private perfMark: PerformanceMarker;

    constructor(private servicesConfig: IAppConfig, name: string, version: string) {
        this.logger = new ELCLogger({
            serviceName: name,
            serviceVersion: version,
            environment: root.env,
            buid: root.buid
        });
        this.perfMark = new PerformanceMarker(this.logger, name);
    }

    private isServiceExcluded = (serviceName: string) => {
        const name = serviceName.toLowerCase();

        return EXCLUDED_SERVICES.some(excSrv => name.includes(excSrv));
    };

    private getNonStartedServices = () => {
        const serviceNames = Object.keys(getServices());
        const services = Object.values(getServices());

        return services.filter((srv: AllServicesTypes, index: number) => {
            let isNonStarted = false;

            const serviceName = (srv && srv.name) || serviceNames[index];

            try {
                isNonStarted =
                    !hasServiceStarted(srv) &&
                    isServiceLazy(srv as AllUpdatedServicesTypes) &&
                    !this.isServiceExcluded(serviceName);
            } catch (error) {
                this.logger.error({
                    message: `Fail filtering service - ${serviceName}`,
                    triggerType: TriggerType.render,
                    payload: {
                        error,
                        context: {
                            serviceRegistry: getServices(),
                            service: srv
                        }
                    }
                });
            }

            return isNonStarted;
        }) as ILazyServiceRegistryComponent[];
    };

    public getViewManager(viewName: string): ViewManager {
        let view = this.views.get(viewName);

        if (!view) {
            view = new ViewManager(viewName, this.logger);
            this.views.set(viewName, view);
        }

        return view;
    }

    public async startService(service: AllUpdatedServicesTypes) {
        const { GlobalServiceBus, ServiceBusTopics } = root;

        try {
            this.perfMark.startMark(`start_lazy_service_${service.name}`);
            await service.start(this.servicesConfig);
            this.perfMark.endMark(`end_lazy_service_${service.name}`);
            GlobalServiceBus.emit(ServiceBusTopics.events.SERVICE_STARTED, {
                serviceName: service.name
            });
        } catch (error) {
            this.logger.error({
                triggerType: TriggerType.render,
                message: `Error starting the service [${service.name}]`,
                payload: {
                    error
                }
            });
        }
    }

    // TODO: remove after SDFEFND-1853
    public async startLazyServices() {
        if (!this.lazyServicesStarted) {
            const nonStartedServices = this.getNonStartedServices();

            for (const service of nonStartedServices) {
                await this.startService(service);
            }

            this.lazyServicesStarted = true;
        }
    }
}

export function getViewsManager(name: string, version: string) {
    if (!root.ViewsManager) {
        root.ViewsManager = new ViewsManager(
            {
                businessUnitId: root.buid || '',
                env: root.env || ''
            },
            name,
            version
        );
    }

    return root.ViewsManager;
}
